import { debug } from 'console';
import { Nominal } from 'lightweight-charts';
import { DGDrawingServiceGlobal } from 'src/app/Services/DrawingService';
import { Series } from '../../model/series';
import { ExtensionType, priceExtendedType, PriceLineSource } from '../../model/series-options';

import { SeriesHorizontalLinePaneView } from './series-horizontal-line-pane-view';
import { activeRetracement } from '../../../../ActiveRetracements';

export class SeriesPriceLinePaneView extends SeriesHorizontalLinePaneView {
  public constructor(series: Series) {
    super(series);
    // series.las
  }

  protected _updateImpl(height: number, width: number): void {
    const data = this._lineRendererData;
    data.visible = false;

    const seriesOptions = this._series.options();
    if (!seriesOptions.priceLineVisible) {
      return;
    }

    const lastValueData = this._series.lastValueData(undefined, seriesOptions.priceLineSource === PriceLineSource.LastBar);
    if (lastValueData.noData) {
      return;
    }

    data.visible = true;
    data.y = lastValueData.coordinate;
    data.color = this._series.priceLineColor(lastValueData.color);

    data.width = width;
    data.height = height;
    data.lineWidth = seriesOptions.priceLineWidth;
    data.lineStyle = seriesOptions.priceLineStyle;


    // var serieIndex = this._series.serieIndex;
    // let check = DGDrawingServiceGlobal.drawingService().notificationDisplayer.signalSeriesIndexMap.get(serieIndex);
    // if(check)
    // {
    //   //console.log("check",check);
    // }

    if (seriesOptions.priceLineExtended) {
      //console.log(serieIndex);
      var serieIndex = this._series.serieIndex;
      let model = DGDrawingServiceGlobal.drawingService().chart.chart.getChartModel();
      let activeSeries = model.getSeries();


      DGDrawingServiceGlobal.drawingService().excludeService.retracementVerticalLineMap

      let selectedSerie = activeSeries.find(v => {
        return v.serieIndex == serieIndex
      })

      let serieNum = DGDrawingServiceGlobal.drawingService().excludeService.getVerticalMap(serieIndex);
      let aB = DGDrawingServiceGlobal.drawingService().activeRetracements.excludesService.activeBars.get(serieNum);

      let barSerie = activeSeries.find(v => {
        return v.serieIndex == serieNum
      })

      let notifSerieNum = DGDrawingServiceGlobal.drawingService().notificationDisplayer.signalSeriesIndexMap.get(serieIndex);

      let finded = [...DGDrawingServiceGlobal.drawingService().activeRetracements.activeRetracements.values()].find(v => {
        return v.retracement.baseLine.getSerieIndex() == serieNum
      })

      let findedCoord = (finded) ? finded.retracement.selectedSerie : selectedSerie;

      let priceStart = null;
      let priceEnd = null;
      if (barSerie) {
        try {
          if (barSerie._data._bars._items.length > 0) {
            priceStart = (barSerie._data._bars._items[0].value[0] < barSerie._data._bars._items[0].value[3]) ? barSerie._data._bars._items[0].value[0] : barSerie._data._bars._items[0].value[3];
            priceEnd = (barSerie._data._bars._items[0].value[0] < barSerie._data._bars._items[0].value[3]) ? barSerie._data._bars._items[0].value[3] : barSerie._data._bars._items[0].value[0];
          }
        }
        catch (e) {
          //console.log("e")
        }
      }

      if ((selectedSerie._paneView as any)._items[1] == undefined) {

        let val = model._timeScale.indexToCoordinate(selectedSerie._data._bars._items[0].index);

        if (barSerie) {
          if (barSerie._data._bars._items.length > 0) {
          val = model._timeScale.indexToCoordinate(barSerie._data._bars._items[0].index);
          }
        }

        data.x = val;
        let x2 = model._timeScale.indexToCoordinate(selectedSerie._data._bars._items[0].index);

        if (barSerie && barSerie._data._bars._items.length > 0 && findedCoord._data._bars._items[1]!=undefined) {
          try{
          x2 = model._timeScale.indexToCoordinate(findedCoord._data._bars._items[1].index);
          }
          catch(e)
          {
            //console.log(e);
          }
        }

        if ((finded) && finded.expanded == false) {
          data.width = data.x + 30;
        }
        else {

          if (seriesOptions.priceLineExtendedType == ExtensionType.None) {
            data.width = x2;//data.x + 200 ;
          }


          if (seriesOptions.priceLineExtendedType == ExtensionType.Right) {
            if (!barSerie) {
              data.width = val + 10000;
            }
          }

          if (seriesOptions.priceLineExtendedType == ExtensionType.Left) {
            data.x = 0 as Nominal<number, "Coordinate">;
            data.width = val
          }

          if (seriesOptions.priceLineExtendedType == ExtensionType.Both) {
            data.x = 0 as Nominal<number, "Coordinate">;
            data.width = 100000
          }


          if (barSerie)
          {
        //    //console.log("1 - barSerie.serieIndex",barSerie.serieIndex);
              DGDrawingServiceGlobal.drawingService().excludeService.addOrUpdateCartessianMap(barSerie.serieIndex, val, data.width, priceStart, priceEnd);
          }

          if(notifSerieNum)          
          {
        //    //console.log("notifSerieNum");
            DGDrawingServiceGlobal.drawingService().signalService.addOrUpdateCartessianMap(serieIndex, val, data.width, priceStart, priceEnd);
          }


        };

        return
      }
      let newXE = (selectedSerie._paneView as any)._items[1].x;

      let newX = (selectedSerie._paneView as any)._items[0].x;
      data.x = newX as Nominal<number, "Coordinate">;

      let old = data.x;

      if (finded&&finded.expanded == false) {
        data.width = data.x + 30;
      }
      else {

        if (seriesOptions.priceLineExtendedType == ExtensionType.None) {
          //  let old = data.x;
          data.width = Number(data.x) + (newXE - newX);
        }

        if (seriesOptions.priceLineExtendedType == ExtensionType.Right) {
          let old = data.x;
        }

        if (seriesOptions.priceLineExtendedType == ExtensionType.Left) {
          //   let old = data.x;
          data.x = 0 as Nominal<number, "Coordinate">;
          data.width = old
        }

        if (seriesOptions.priceLineExtendedType == ExtensionType.Both) {
          //    let old = data.x;
          data.x = 0 as Nominal<number, "Coordinate">;
          data.width = 100000
        }

      }

      if(barSerie)
      {
         DGDrawingServiceGlobal.drawingService().excludeService.addOrUpdateCartessianMap(barSerie.serieIndex, old, data.width, priceStart, priceEnd);
      }
     
     // DGDrawingServiceGlobal.drawingService().signalService.addOrUpdateCartessianMap(barSerie.serieIndex, old, data.width, priceStart, priceEnd);
   //   jQuery(".strike-click-wrapper").remove();

      if(notifSerieNum)          
      {
        //console.log("notifSerieNum 1")
        DGDrawingServiceGlobal.drawingService().signalService.addOrUpdateCartessianMap(serieIndex, old, data.width, priceStart, priceEnd);
      }

    }





  }
}
